/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * AI reasoning log entry from workflow execution.
 * 
 * This schema is shared across multiple interfaces:
 * - REST API: GET /api/comparisons/:id/logs endpoint
 * - SSE Streaming: snapshot and reasoning events
 * 
 * Note: The SSE implementation uses a TypeScript type with string dates (for direct JSON 
 * serialization in text/event-stream), while the generated OpenAPI client uses Date objects 
 * (for automatic deserialization). Both represent the same logical structure and serialize 
 * to identical JSON on the wire.
 * 
 * See: src/domains/sse/TYPE_SHARING.md for detailed explanation of type sharing.
 * 
 * @export
 * @interface GetComparisonLogs200ResponseInner
 */
export interface GetComparisonLogs200ResponseInner {
    /**
     * Unique log entry ID
     * @type {number}
     * @memberof GetComparisonLogs200ResponseInner
     */
    id: number;
    /**
     * Name of the activity that generated this log
     * @type {string}
     * @memberof GetComparisonLogs200ResponseInner
     */
    activityName: string;
    /**
     * The actual reasoning text/content
     * @type {string}
     * @memberof GetComparisonLogs200ResponseInner
     */
    reasoningContent: string;
    /**
     * Number of tokens used (if available)
     * @type {number}
     * @memberof GetComparisonLogs200ResponseInner
     */
    tokenCount?: number | null;
    /**
     * When this log entry was created
     * @type {Date}
     * @memberof GetComparisonLogs200ResponseInner
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the GetComparisonLogs200ResponseInner interface.
 */
export function instanceOfGetComparisonLogs200ResponseInner(value: object): value is GetComparisonLogs200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('activityName' in value) || value['activityName'] === undefined) return false;
    if (!('reasoningContent' in value) || value['reasoningContent'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function GetComparisonLogs200ResponseInnerFromJSON(json: any): GetComparisonLogs200ResponseInner {
    return GetComparisonLogs200ResponseInnerFromJSONTyped(json, false);
}

export function GetComparisonLogs200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetComparisonLogs200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'activityName': json['activityName'],
        'reasoningContent': json['reasoningContent'],
        'tokenCount': json['tokenCount'] == null ? undefined : json['tokenCount'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function GetComparisonLogs200ResponseInnerToJSON(json: any): GetComparisonLogs200ResponseInner {
    return GetComparisonLogs200ResponseInnerToJSONTyped(json, false);
}

export function GetComparisonLogs200ResponseInnerToJSONTyped(value?: GetComparisonLogs200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'activityName': value['activityName'],
        'reasoningContent': value['reasoningContent'],
        'tokenCount': value['tokenCount'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

